import * as utils from './utils.js';

// namespace

var parser = {};


// parse results
//
// input  : Sparql JSON response
// output : An array of hashes representing rows. Each hash has column names (keys) and their content (values)

export function parseResults (selectedSearchType, response) {

  // extract data out of json response of sparql service
  const allResults = response.data["results"]["bindings"];
  const allItems = [];

  // allResults contains a SET of hashes representing the rows
  for (var oneIndex in allResults)
  {
      // oneResult represents one row. It contains a hash with a column name (key) and (meta)data like {"type": ..., "xml:lang": ..., "value": ...} (value)
      var oneResult = allResults[oneIndex];
      var oneRecord = {};

      // we will assign a color to the lemma column, in such a way that the users can easily distinguish different lemmata
      let rowColor = null;
      let cellVariants = {};

      // look through all columns (keys) and extra the value property 
      for (var onePart in oneResult)
      {
        var val = oneResult[onePart]["value"];

        // in advanced search, remove the URLs prefixes
        if (selectedSearchType == 'advanced_search')  
          {
            val = utils.formatThat(val);
          }
        oneRecord[onePart] = val;  

        // if we have a color code in the query results, make sure it's included
        if (onePart == 'colorId')
        {
          rowColor = computeColor(val);
        }

      }

      // https://bootstrap-vue.js.org/docs/components/table
      if (rowColor != null)
      {
        // add row color to all columns having 'lemma' in their name!
        for (var onePart in oneResult)
        {
          if (onePart.toLowerCase().indexOf("lemma")>=0)
          {
            cellVariants[onePart] = rowColor;            
          }
        }
        oneRecord["_cellVariants"] = cellVariants;
      }      

      allItems.push(oneRecord);
  }

  return allItems;
};


// compute a color given some numeric input
export function computeColor(value){
  
  // if input contains more than the id (prefix etc), get rid of all non numeric things
  if (isNaN(value))
  {
    // cut off prefix, hopefully we'll end up with only digits
    value = utils.formatThat(value);

    // if we end up with nothing, compute some predictable value out of the string
    if (value.replace( /\D+/g, '') == '')
      value = getAscii(value);
    // else carry on with the digits we have
    else
      value = value.replace( /\D+/g, '');
  };

  // https://bootstrap-vue.js.org/docs/reference/color-variants/
  var colorNameArr = [  "primary", 
                        "secondary", 
                        "success", 
                        "warning", 
                        "danger",  // a bit pink!
                        "info" 
                      //  "dark"  // this color doesn't fit well with the yellow highlighting
                      ];

  var intVal = ( parseInt(value) % (colorNameArr.length) );

  var colorName = colorNameArr[intVal];

  return colorName;
}


// compute ascii value of a word
export function getAscii(word){
  var value = 0;
  for (var i=0; i<word.length; i++)
  {
    value += word.charCodeAt(i);
  }
  return value;
}


export function removeUrls(str){
  var hashChar = str.lastIndexOf("#");
  var slashChar = str.lastIndexOf("/");

  var cutFrom = hashChar;
  if (slashChar>hashChar) cutFrom = slashChar;
}



export function countProperties(obj) {  
  var count = 0;
  for(var prop in obj) {
      ++count;
  }
  return count;
}


// compute relevance of a result, given the number of filled fields
export function addRelevance(res){

  // first loop once through all results to get the full list of fields 
  // (we need to so do, because some records contains only a few fields)

  let maxObjectSize = 1; // min-value can't be 0, otherwise we will get devide by zero errors
  for (var i=0; i<res.length; i++)
  {
    let thisObjectSize = countProperties(res[i]);
    if ( thisObjectSize > maxObjectSize)
      maxObjectSize = thisObjectSize;
  }

  // loop again and compute relevance given number of useful fields against total number of fields in largest record
  // (t.i. the record that has the largest number of fields filled in)
  for (var i=0; i<res.length; i++)
  {
    let sumOfUsefulFields = 0;
    let listOfColorIdFields = [];    

    // we will assign a color to the lemma columns, in such a way 
    // that the users can easily distinguish paradigms (and such) of different lemmata
    let rowColor = null; 
    let cellVariants = {};

    // first take care of relevance
    for (var oneField in res[i])
    {
     // register useful field
     if (typeof res[i][oneField] != 'undefined' && res[i][oneField] != null && res[i][oneField] != '' && res[i][oneField] != 'undefined')
      {
        sumOfUsefulFields++;        
      }

      // register colorId field
     if (oneField.toLowerCase().endsWith("colorid"))
      {
        listOfColorIdFields.push(res[i][oneField]);
      }
    }

    let relevance = (100*( sumOfUsefulFields / maxObjectSize )).toFixed(2);

    res[i]['relevance'] = relevance +" %";


    // as a final step, add color to row too, based on row id
    // https://bootstrap-vue.js.org/docs/components/table    
    rowColor = computeColor( utils.coalesce(listOfColorIdFields) );    

    if (rowColor != null)
    {
      // columns with 'lemma' in their names get the row color
      for (var oneField in res[i])
      {
        if (oneField.toLowerCase().indexOf("lemma")>=0)
        {
          cellVariants[oneField] = rowColor;          
        }
      }
      res[i]["_cellVariants"] = cellVariants;
    }
     
  }

  return res;
}




export function buildResultWithRelevance(data){

  if (typeof data == 'undefined') data = [];

    data = addRelevance(data);

    return data;
}


export default parser;



// WEBPACK FOOTER //
// ./src/js/parser.js